// ============================================================================
// The Hive API client — the ONLY place the frontend talks to the backend.
// All provider keys stay server-side; this just calls our own /api/* routes.
// ============================================================================

async function req(method, path, body) {
  const res = await fetch(path, {
    method,
    headers: body ? { 'content-type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  })
  if (res.status === 401) { location.href = '/login'; throw new Error('unauthorized') }
  const ct = res.headers.get('content-type') || ''
  const data = ct.includes('application/json') ? await res.json() : await res.text()
  if (!res.ok) throw new Error((data && data.error) || res.statusText)
  return data
}

export const api = {
  get:  (p) => req('GET', p),
  post: (p, b) => req('POST', p, b),
  patch: (p, b) => req('PATCH', p, b),
  del:  (p, b) => req('DELETE', p, b),
  // Current signed-in user (identity + role), for RBAC-aware UI + audit context.
  me:   () => req('GET', '/api/me'),
}
